<template>
  <div>
    <default-dialog fullscreen :loading="loading_employees">
      <template slot="title">
        Detalhes do Funcionário
      </template>
      <template slot="content">
        <v-container>
          <v-expansion-panels flat active-class="elevation-4" multiple  v-if="!loading_employees" popout v-model="panel">
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-information</v-icon>
                  Detalhes do funcionário
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <employee-edit-info-dialog :change_dialog="edit.info" :employee="employee" @update="startUpdateEmployee('info', $event)" @close="edit.info = false"></employee-edit-info-dialog>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit :disabled="!user_allowed" small class="ml-2 " @click="edit.info = true">
                    </f-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-row align='center' justify="space-around">
                      <v-spacer></v-spacer>
                      <v-col cols='6' sm='5' md='3'>
                        <show-avatar @doneAvatar="handleDoneAvatar" :oneEmployee="employee"></show-avatar>                        
                      </v-col>
                      <v-col cols='6' sm="7" md="9">
                        <EmployeeInfoForm read_only :user_attributes="employee?.data?.attributes" :teamModel="employee?.data?.attributes" has_email></EmployeeInfoForm>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="isSeller()" class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold ">
                <div>
                  <v-icon size="19" color="red">mdi-account-multiple</v-icon>
                  Carteira de Clientes
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end" v-if="isDirector()">
                    <f-btn v-if="user_allowed" edit small class="ml-2" @click="edit.client_portfolios = true"></f-btn>
                  </v-card-title>
                  <v-card-text>
                    <DialogEditClientPortfolio :API="{MODEL:'Employee', METHOD:'update'}" @updated="clearAndGetData" :change_dialog="edit.client_portfolios" :model="employee?.data?.attributes" @close="edit.client_portfolios = false"></DialogEditClientPortfolio>
                    <div v-if="employee?.data?.attributes?.client_portfolio_ids?.length == 0">
                      <span class="subtitle-1">
                        <v-icon left>mdi-account-multiple-remove</v-icon>
                        Cliente não cadastrado em nenhuma carteira                            
                      </span>
                    </div>
                    <div v-if="employee?.data?.attributes?.client_portfolio_ids?.length > 0">
                      <ChooseClientPortfolioForm readonly :model="employee?.data?.attributes"></ChooseClientPortfolioForm>
                    </div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-domain</v-icon>
                  Módulos do funcionário
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <EditSolutions :model="{text:'funcionário', API:'Employee', METHOD:'update'}" :model_modality_ids="employee?.data?.attributes?.modality_ids"/>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-cash</v-icon>
                  Perfil financeiro
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <employee-edit-financial-dialog :change_dialog="edit.financial" :employee="employee" @update="startUpdateEmployee('financial', $event)" @close="edit.financial = false"></employee-edit-financial-dialog>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit :disabled="!user_allowed" small class="ml-2" @click="edit.financial = true">
                    </f-btn>
                  </v-card-title>
                  <v-card-text>
                    <EmployeeFinancialForm read_only :employee="employee"></EmployeeFinancialForm>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-account-box</v-icon>
                  Contatos
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <employee-edit-contacts-dialog :change_dialog="edit.contacts" :employee="employee" @update="startUpdateEmployee('contacts', $event)" @close="edit.contacts = false"></employee-edit-contacts-dialog>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit :disabled="!user_allowed" small class="ml-2" @click="edit.contacts = true">
                    </f-btn>
                  </v-card-title>
                  <v-card-text>
                    <template v-if="employee?.data.attributes.contacts != null">
                      <div v-for="(con, index) in employee?.data.attributes.contacts.data" :key="index">
                        <ContactForm :contact="con.attributes" read_only></ContactForm>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-bank</v-icon>
                  Dados Bancários
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <employee-edit-account-dialog :change_dialog="edit.account" :employee="employee" @update="startUpdateEmployee('account', $event)" @close="edit.account = false"></employee-edit-account-dialog>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit :disabled="!user_allowed" small class="ml-2" @click="edit.account = true">
                    </f-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-col cols='12' class="d-flex">
                    </v-col>
                    <template v-if="employee?.data.attributes.accounts != null">
                      <div v-for="(acc, index) in employee?.data.attributes.accounts.data" :key="index">
                        <BankAccountForm only_cpf :account="acc.attributes" read_only></BankAccountForm>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-map</v-icon>
                  Endereço
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <employee-edit-address-dialog :change_dialog="edit.address" :employee="employee" @update="startUpdateEmployee('address', $event)" @close="edit.address = false"></employee-edit-address-dialog>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit :disabled="!user_allowed" small class="ml-2" @click="edit.address = true">
                    </f-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-row justify="space-around">
                      <template v-if="employee?.data.attributes.address != null">
                        <AddressForm :address="employee?.data.attributes.address.data.attributes" read_only></AddressForm>
                      </template>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-account-cog</v-icon>
                  {{employee?.data.attributes.status_name == "Active" ? "Desabilitar" : "Habilitar"}} acesso
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-row justify="space-around">
                    <v-col class="d-flex">
                      <v-btn :disabled="!user_allowed" color="error" big @click="toggleEnableEmployee()"><v-icon small
                          left>mdi-delete</v-icon>{{
                            employee?.data.attributes.status_name == "Active" ?
                              "Desabilitar" : "Habilitar"
                          }} acesso do funcionário!</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <template slot="actions">
        <f-btn close @click="goBack()"></f-btn>
      </template>
    </default-dialog>
    <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>

    <dialog-list-comission v-if="edit.commission_products" :editing="edit.comission1"
      @close="edit.commission_products = false; edit.comission1 = false"
      :main_data="Object.keys(new_employee).length > 1 ? new_employee : { comissions_attributes: [], ...employee?.data.attributes }">
    </dialog-list-comission>

  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { VMoney } from 'v-money'
import Api from '@/api/index';
import validations from "@/mixins/validations.js"
import getters from "@/_backoffice/_registrations/mixins/getters.js"

export default {
  name:"ShowEmployee",
  mixins:[ validations, getters],
  directives: { money: VMoney },
  components: {
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
    BankAccountForm: () => import("@/_backoffice/_registrations/components/shared/forms/BankAccountForm.vue"),
    ContactForm:() => import("@/_backoffice/_registrations/components/shared/forms/ContactForm.vue"),
    DialogListComission: () => import('@/_backoffice/_registrations/components/supplier/products/DialogListComission.vue'),
    EmployeeEditInfoDialog: () => import("@/_backoffice/_registrations/components/employee/show/edit/EmployeeEditInfoDialog.vue"),
    EmployeeEditAccountDialog: () => import("@/_backoffice/_registrations/components/employee/show/edit/EmployeeEditAccountDialog.vue"),
    EmployeeEditContactsDialog: () => import("@/_backoffice/_registrations/components/employee/show/edit/EmployeeEditContactsDialog.vue"),
    EmployeeEditFinancialDialog: () => import("@/_backoffice/_registrations/components/employee/show/edit/EmployeeEditFinancialDialog.vue"),
    EmployeeEditAddressDialog: () => import("@/_backoffice/_registrations/components/employee/show/edit/EmployeeEditAddressDialog.vue"),
    EmployeeFinancialForm: () => import("@/_backoffice/_registrations/components/employee/forms/EmployeeFinancialForm.vue"),
    EmployeeInfoForm: () => import("@/_backoffice/_registrations/components/employee/forms/EmployeeInfoForm.vue"),
    ShowAvatar: () => import('./show/ShowAvatar.vue'),
    ChooseClientPortfolioForm: () => import("@/_backoffice/_registrations/components/shared/client_portfolio/ChooseClientPortfolioForm.vue"),
    DialogEditClientPortfolio: () => import("@/_backoffice/_registrations/components/client/register/DialogEditClientPortfolio.vue"),
    EditSolutions: () => import('@/_backoffice/_registrations/components/shared/EditSolutions.vue'),
  },
  data() {
    return {
      new_employee: { 
        user_attributes: { 
          name:'',
          cpf:'',
          email:'',
        },
      },
      edit: {
        info: false,
        role: false,
        financial: false,
        contacts: false,
        account: false,
        address: false,
        client_portfolios: false,
        companies: false,
      },
      panel: [0,1],
      update_actions_map:{
        'info': 'updateInfo',
        'financial': 'updateFinancial',
        'contacts': 'updateContact',
        'account': 'updateAccount',
        'address': 'updateAddress',
        'companies': 'updateCompanies'
      },
      saving:false,
      ready_to_show_manager_or_subordinates: true,
      
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false
      },
      loading:{
        employee: true,
        employee_company: true,
      },
      employee: { data: { attributes: {} }, employee_company: {name: ''}}
    }
  },
  methods: {
    getData(){
      this.indexStatuses()
      this.getEmployee()    
    },
    getEmployee(){
      this.loading.employee = true
      Api.Employee.show(this.$route.params.id, {}).then(r => r.data).then(data=> {
        this.employee = {...data}
        this.getEmployeeCompany(this.employee?.data.attributes.company_id)
      }).catch(err => {
        console.log(err)
      }).finally(()=>{
        this.loading.employee = false
      })
    },
    getEmployeeCompany(company_id){
      this.loading.employee_company = true
      Api.Company.show(company_id).then((r) => {
        this.employee.employee_company = {...r.data.data.attributes}
      }).finally(() => {
        this.loading.employee_company = false
      })
    },
    clearAndGetData(){
      this.closeDialogs()
      this.employee = null
      this.getData()
    },

    handleDoneAvatar(e) {
      this.clearAndGetData() //this.resetEmployee(e)
    },

    startUpdateEmployee(kind, new_employee) {
      this.swallConfirmation({
        title: 'Deseja atualizar informações do funcionário?',
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {

          this.saving = true
          Api.Employee[ this.update_actions_map[kind] ](new_employee, new_employee.id).then(()=>{
            this.addNotification({type: 'success',  msg: `Atualizado com sucesso!.`})
            this.clearAndGetData()
          })
          .catch(er => {
            this.addNotification({type: 'error',  msg: `${er}`})
          })
          .finally(()=>{
            this.saving = false
          })
        }
      })
    },
    toggleEnableEmployee() {
      let {  id, status_name } = this.employee?.data.attributes
      let status_id = this.allStatuses.find(o => o.attributes.title == (status_name == "Active" ? "Inactive" : "Active")).id
      let employee = { id, status_id }
      this.swallConfirmation({
        title: `Tem certeza que deseja ${status_name == 'Active' ? 'desabilitar' : 'habilitar'} o acesso deste funcionário?`,
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {
          this.saving = true
          Api.Employee.update(employee)
          .then(() => {
            this.addNotification({type: 'success',  msg: `Funcionário ${status_name == 'Active' ? 'desabilitado' : 'habilitado'} com sucesso`})
            this.$emit('toggleEmployee', false)
            this.clearAndGetData()
          }).catch(function (error) {
            console.log(error);
          }).finally(()=>{
            this.saving = false
          })
        }
      })
    },
    closeDialogs(){
      this.edit = {
        info: false,
        financial: false,
        contacts: false,
        account: false,
        address: false,
        companies: false,
        client_portfolios: false,
      }
    },
    goBack(){
      this.$router.push({name: "EmployeeList"})
    },
    ...mapActions({
      indexStatuses: 'Status/index',
    })
  },
  computed: {
    loading_employees(){
      return this.loading.employee || this.loading.employee_company
    },
    user_allowed() {
      return this.has_roles(['Director', 'Manager', 'SalesExecutive'])
    },
    ...mapState({
      allStatuses: state => state.Status.allStatuses,
    })
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>
h3 {
  -webkit-text-fill-color: red !important;
}

.bcom-red:hover {
  -webkit-text-fill-color: red !important;
}

.bcom-green:hover {
  -webkit-text-fill-color: limegreen !important;
}

.bcom-yellow:hover {
  /* -webkit-text-fill-color: #FFC107 !important; amber darken-1 */
  -webkit-text-fill-color: #673AB7 !important;
}

h4 {
  -webkit-text-fill-color: red !important;
}
</style>
